export default __webpack_public_path__ + "static/media/satellite-map.3ced6bd1.png";